<div class="left">
  <div
    class="transaction-row"
    data-cy="transaction-row"
    [ngClass]="{ 'transaction-row--active': type === 'detailed'}"
    (click)="type === 'detailed' && transactionSelected(transaction.transactionId)"
    (keydown.space)="type === 'detailed' && transactionSelected(transaction.transactionId)"
    (keydown.enter)="type === 'detailed' && transactionSelected(transaction.transactionId)"
    tabindex="0"
  >
    <div class="transaction-main-line">
      <div class="transaction-type" data-cy="transaction-type">
        @if (type === 'detailed') {
          {{ transaction.portfolio.name }}
        } @else {
          @switch (transaction.uiType) {
            @case ('DEPOSIT') {
              {{ 'investmentDetail.transactionHistory.deposit' | translate }}
            }
            @case ('WITHDRAWAL') {
              {{ 'investmentDetail.transactionHistory.withdrawal' | translate }}
            }
            @case ('BUY') {
              {{ 'investmentDetail.transactionHistory.buy' | translate }}
            }
            @case ('SELL') {
              {{ 'investmentDetail.transactionHistory.sell' | translate }}
            }
            @case ('FX_TRANSACTION') {
              {{ 'investmentDetail.transactionHistory.fx' | translate }}
            }
            @case ('DIVIDEND') {
              {{ 'investmentDetail.transactionHistory.dividend' | translate }}
            }
            @case ('OPF_MANAGEMENT_FEE_REFUND') {
              {{ 'investmentDetail.transactionHistory.opfFeeRefund' | translate }}
            }
            @case ('ROUNDING_RETURN') {
              {{ 'investmentDetail.transactionHistory.roundingReturn' | translate }}
            }
            @case ('FEE') {
              {{ 'investmentDetail.transactionHistory.fee' | translate }}
            }
          }
        }
      </div>
      <div class="transaction-amount" data-cy="transaction-amount">
        @if (transaction.corporateAction && transaction.type === 'CORPORATE_ACTION') {
          {{ transaction.corporateAction.uiLabel }}
        } @else {
          {{ transactionValueSign }} {{ transaction.amount | transactionPrice: transaction.instrument.currencyCode: localization }}
        }
      </div>
    </div>
    <div class="transaction-secondary-line">
      <div class="transaction-date" data-cy="transaction-date">
        {{ transaction.transactionTimestamp | date:'d. MMMM yyyy' }}
      </div>
      <div class="right-column">
        @if (transaction.vat) {
          <div class="transaction-vat">
            ({{ 'moneyAndTransactions.vat' | translate }} {{ transaction.vat | price: transaction.instrument.currencyCode:2 }})
          </div>
        }
      @if (type === 'detailed') {
          <div class="transaction-detailed-type">
            <div class="transaction-description" data-cy="transaction-description">
              @if (transaction.type !== 'OPF_MANAGEMENT_FEE_REFUND') {
                  {{ transaction.description }}
              } @else {
                {{ 'moneyAndTransactions.refundDescription' | translate }}
              }
            </div>
            <span class="transaction-separator" aria-hidden="true"></span>
            <span class="transaction-ui-type">
                      @switch (transaction.uiType) {
                        @case ('DEPOSIT') {
                          {{ 'investmentDetail.transactionHistory.deposit' | translate }}
                        }
                        @case ('WITHDRAWAL') {
                          {{ 'investmentDetail.transactionHistory.withdrawal' | translate }}
                        }
                        @case ('BUY') {
                          {{ 'investmentDetail.transactionHistory.buy' | translate }}
                        }
                        @case ('SELL') {
                          {{ 'investmentDetail.transactionHistory.sell' | translate }}
                        }
                        @case ('FX_TRANSACTION') {
                          {{ 'investmentDetail.transactionHistory.fx' | translate }}
                        }
                        @case ('DIVIDEND') {
                          {{ 'investmentDetail.transactionHistory.dividend' | translate }}
                        }
                        @case ('OPF_MANAGEMENT_FEE_REFUND') {
                          {{ 'investmentDetail.transactionHistory.opfFeeRefund' | translate }}
                        }
                        @case ('ROUNDING_RETURN') {
                          {{ 'investmentDetail.transactionHistory.roundingReturn' | translate }}
                        }
                        @case ('FEE') {
                          {{ 'investmentDetail.transactionHistory.fee' | translate }}
                        }
                        @case ('CORPORATE_ACTION') {
                          {{ 'investmentDetail.transactionHistory.corporateAction' | translate }}
                        }
                      }
                  </span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="right">
  @if (type === 'detailed') {
    <svg-icon
      src="assets/icons/arrow-link.svg"
      class="arrow-link-icon"
      aria-hidden="true"
      (click)="transactionSelected(transaction.transactionId)"
    ></svg-icon>
  }
</div>
